import { ArrayWithLookup } from './arrayWithLookup'

export class ArrayWithIdLookup<T extends { id: string }> extends ArrayWithLookup<T> {
  constructor(data?: T[]) {
    super(data || [], item => item.id)
  }
}
